export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Log på",
    "login.form.hint.user": "Login",
    "login.form.hint.password": "Adgangskode",
    "login.form.checkbox.remember-me": "Husk mig",
    "login.form.button.sign-in": "Log på",
    "login.form.message.invalid-user-credentials": "Login eller adgangskode er forkert",
    "login.form.message.account-temporarily-locked": "Din konto er midlertidigt låst. Vend tilbage om 5 minutter",
    "login.form.message.user-required": "Angiv et login",
    "login.form.message.password-required": "Angiv en adgangskode",
    "login.form.button.forgot-password": "Glemt adgangskode?",
    "error.mfa-required.title": "Opsæt 2FA",
    "error.mfa-required.message1": "Tofaktorgodkendelse (2FA) er påkrævet for at beskytte din konto.",
    "error.mfa-required.message2": "Du bliver omdirigeret til dine kontoindstillinger i det online betjeningspanel. Aktivér 2FA, følg opsætningsinstruktionerne, og vend derefter tilbage hertil.",
    "error.mfa-required.learnMore": "Få mere at vide om 2FA",
    "error.mfa-required.continue": "Fortsæt",
    "error.root-admin-login.title": "Fejl 403 – forbudt",
    "error.root-admin-login.message": "Du er logget på som en skrivebeskyttet administrator. Hvis du vil have adgang til Web Recovery-konsollen, skal du i stedet logge på kundelejer eller administrator",
    "error.server-busy.message": "Serveren er optaget. Prøv igen senere.",
    "error.network-connection.title": "Fejl i netværksforbindelse",
    "error.network-connection.message": "Kontrollér internetforbindelsen, og prøv igen.",
    "error.internal-server-error.title": "Intern serverfejl",
    "error.internal-server-error.message": "Kontakt support, og giv dem fejloplysningerne, for at løse fejlen:",
    "error.internal-server-error.copy.button": "Kopiér"
};
